export default __webpack_public_path__ + "static/mylist-325694b5530b24a14ffcb17a752c2164.png";